import http from '@/plugins/http';
import StatsTranformer from '../../transformers/data/stats';

export default (customerId) => new Promise((res, rej) => {
  http.get(`/v3/customers/${customerId}/stats?statistics[]=countStudentsToGiveFeedback&statistics[]=countStudentsToValidate&statistics[]=countQuoteToValidate&statistics[]=countContractsToSign`)
    .then((response) => {
      const results = StatsTranformer.fetch(response.data);
      res(results);
    })
    .catch((error) => {
      rej(error);
    });
});
